import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { AccountService } from "app/shared/services/account.service";
import { LANGUAGES } from "app/languages";
import { AppTranslateService } from "app/shared/services/app-translate.service";
import { slide } from "../introduction.component";

@Component({
  selector: "app-desktop-introduction",
  templateUrl: "desktop-introduction.component.html",
  styleUrls: ["desktop-introduction.component.scss"],
  standalone: false,
})
export class DesktopIntroductionComponent {
  @Input() currentSlide: number;
  @Input() isFirstStep: boolean = true;
  @Input() isTwoButtons: boolean = true;
  @Input() isFinalStep: boolean = false;

  @Output() previous = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() skip = new EventEmitter<void>();

  @Input() slides: slide[] = [];

  onPrevious() {
    this.previous.emit();
  }

  onNext() {
    this.next.emit();
  }

  onSkip() {
    this.skip.emit();
  }
}
